import Vuex from 'vuex';
import Vue from 'vue';
import User from './user/index';
import Global from './global/index';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    user: User,
    global: Global
  }
});
